import {IPublicClientApplication, RedirectRequest} from "@azure/msal-browser";
import {config} from "../config.ts";
import {useMsal} from "@azure/msal-react";

export function useGetHeaders() {
    const {instance} = useMsal()

    return (contentType: string = 'application/json') => getHeaders(instance, contentType)
}

export async function getHeaders(instance: IPublicClientApplication, contentType: string){
    const loginRequest: RedirectRequest = {
        scopes: config.scopes,
    };

    try {
        const token = await instance.acquireTokenSilent(loginRequest);
        return {headers: {
                'Content-Type': contentType,
                Authorization: 'Bearer ' + token.accessToken,
            }}
    } catch (e) {
        console.error(e)
        instance.logoutRedirect()
    }
}